<template>
  <div>
  <div class="container seg-content general user">
    <section class="home-list">
      <div class="hl-wid ww4 watch-filter">
        <h4>Test stats</h4>
        <form class="user-form filter">
          <div class="filter-field">
            <label>User</label>
            <keyval-select :options="users" v-model="userId" v-on:input="loadWatchStats" />
          </div>
          <div class="filter-field">
            <label>Test</label>
            <keyval-select :options="videos" v-model="videoId" v-on:input="loadWatchStats" />
          </div>
        </form>
      </div>
      <div class="hl-wid ww4 test-totals" v-if="!(userId*1) && !(videoId*1)">
        <h4>Select a user or test</h4>
      </div>
      <div class="hl-wid ww4 test-totals" v-else-if="!(userId*1) && (videoId*1)">
        <h4>Test: {{ currentTest.parent?currentTest.parent.subtitle:currentTest.subtitle }} {{ currentTest.title }}</h4>
        <ul>
          <li v-for="testTakes in usersForTest">
            <span>{{ testTakes.user.firstname }} {{ testTakes.user.lastname }}</span>
            <span>Passed {{ testTakes.answers.filter((a)=>a.passed*1).length }} of {{testTakes.answers.length}}</span>
            <span><a href="" v-on:click.prevent="userId=testTakes.user.id+''; loadWatchStats()">View answers</a></span>
          </li>
        </ul>
      </div>
      <div class="hl-wid ww4 test-totals" v-else-if="(userId*1) && !(videoId*1)">
        <h4>User: {{ currentUser.firstname+" "+currentUser.lastname }}</h4>
        <ul>
          <li v-for="testTakes in testsForUser">
            <span>{{ testTakes.video.parent?testTakes.video.parent.subtitle:testTakes.video.subtitle }} {{ testTakes.video.title }}</span>
            <span>Passed {{ testTakes.answers.filter((a)=>a.passed*1).length }} of {{testTakes.answers.length}}</span>
            <span><a href="" v-on:click.prevent="videoId=testTakes.video.id+''; loadWatchStats()">View answers</a></span>
          </li>
        </ul>
      </div>
      <div class="hl-wid ww4 test-totals" v-else-if="(userId*1) && (videoId*1)">
        <h4>User: {{ currentUser.firstname+" "+currentUser.lastname }}</h4>
        <h4>Test: {{ currentTest.parent?currentTest.parent.subtitle:currentTest.subtitle }} {{ currentTest.title }}</h4>
        <table class="test-answers" v-if="testsFor.qs && testsFor.qs.type=='independent'">
          <tr class="prop adate">
            <th>Date:</th>
            <td v-for="answer in testsFor.answers || []" :title="formatDate(answer.created, 'MMM Do, YYYY h:mma')">{{ formatDate(answer.created, "MMM Do") }}</td>
          </tr>
          <tr class="prop total">
            <th>Total questions:</th>
            <td v-for="answer in testsFor.answers || []">{{ testsFor.qs.independent.questions.length }}</td>
          </tr>
          <tr class="prop treshold">
            <th>Passing score:</th>
            <td v-for="answer in testsFor.answers || []">{{ testsFor.qs.independent.passingScore }}</td>
          </tr>
          <tr class="prop score">
            <th>Score:</th>
            <td v-for="answer in testsFor.answers || []" :class="{pass: answer.result>=testsFor.qs.independent.passingScore}">{{ answer.result }}</td>
          </tr>
          <template v-for="(question, qi) in testsFor.qs.independent.questions">
          <tr class="question">
            <th class="question">{{ question.text }}</th>
            <td v-for="answer in testsFor.answers || []" class="qresult"><em :class="{valid: isAnswerValid(answer, qi)}"></em></td>
          </tr>
          <tr class="answer" v-for="(answer, ai) in question.answers">
            <th class="answer" :class="{correct: answer.valid}">{{ answer.text }}</th>
            <td v-for="answer in testsFor.answers || []" class="aresult"><em :class="{selected: isSelected(answer, qi, ai), correct: isCorrect(answer, qi, ai), valid: isValid(answer, qi, ai)}"></em></td>
          </tr>
          </template>
        </table>
      </div>
    </section>
  
    
    

    
  </div>
  </div>
</template>
<script>
import moment from 'moment';
import formatters from './formatters';
export default {
  mixins: [formatters],
  data: ()=>({
    menuOpen: false,
    dateStart: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dateEnd: moment().subtract(0, "days").format("YYYY-MM-DD"),
    userId: 0,
    videoId: 0,
    mode: 'date',
    items: [],
    items2: [],
    users: {},
    videos: {},
    currentTest: {},
    currentUser: {},
  }),
  computed: {
    usersForTest() {
      var result={};
      if (!this.currentTest.id)
        return result;
      for(var started of this.items2) {
        var v=result[started.user.id]=result[started.user.id] || {};
        v.video=started.video;
        v.user=started.user;
        v.qs=started.video.testqs;
        v.answers=v.answers || [];
      }
      for(var completed of this.items) {
        var v=result[completed.user.id]=result[completed.user.id] || {};
        v.video=completed.video;
        v.user=completed.user;
        v.qs=completed.video.testqs;
        v.answers=v.answers || [];
        v.answers.push({
          answers: completed.answers,
          result: completed.result,
          passed: completed.passed,
          created: completed.created,
        });
      }
      return result;
    },
    testsForUser() {
      var result={};
      if (!this.currentUser.id)
        return result;
      for(var started of this.items2) {
        var v=result[started.video.id]=result[started.video.id] || {};
        v.video=started.video;
        v.qs=started.video.testqs;
        v.answers=v.answers || [];
      }
      for(var completed of this.items) {
        var v=result[completed.video.id]=result[completed.video.id] || {};
        v.video=completed.video;
        v.qs=completed.video.testqs;
        v.answers=v.answers || [];
        v.answers.push({
          answers: completed.answers,
          result: completed.result,
          passed: completed.passed,
          created: completed.created,
        });
      }
      return result;
    },
    testsFor() {
      return this.testsForUser[this.currentTest.id] || {};
    },
  },
  methods: {
    isAnswerValid(answer, qi) {
      var ans=answer.answers.answers[qi] || [];
      var qa=answer.answers.questions.questions[qi].answers;
      for(var i in qa) {
        if ((qa[i].valid) ^ (ans.indexOf(i*1)!=-1))
          return false;
      }
      return true;
    },
    isSelected(answer, qi, ai) {
      var ans=answer.answers.answers[qi] || [];
      return ans.indexOf(ai*1)!=-1;
    },
    isCorrect(answer, qi, ai) {
      var qa=answer.answers.questions.questions[qi].answers;
      return qa[ai].valid;
    },
    isValid(answer, qi, ai) {
      var isSelected=this.isSelected(answer, qi, ai);
      var isCorrect=this.isCorrect(answer, qi, ai);
      return !(isSelected ^ isCorrect);
    },
    formatDuration(duration) {
      var result=[];
      var hours=Math.floor(duration/3600)%60;
      if (hours)
        result.push(hours+"h");
      var minutes=Math.floor(duration/60)%60;
      if (minutes)
        result.push(minutes+"m");
      var seconds=Math.floor(duration)%60;
      result.push(seconds+"s");
      return result.join(" ");
    },
    toggleMenu() {
      this.menuOpen=!this.menuOpen;
      if (!this.menuOpen)
        this.$refs.mobileMenu.menuSubOpen=null;
    },
    action($event) {
      var actionName="action"+($event.name[0].toUpperCase())+($event.name.substring(1));
      
      this[actionName] && this[actionName]($event);
    },
    async loadVideos() {
      var result={};
      var videos=(await api.list("Video", {password: ["<>", ""]})).items;
      for(var video of videos) {
        result[video.id]=((video.parent?video.parent.subtitle:video.subtitle) || "")+" "+video.title;
      }
      result[0]="(all)";
      this.videos=result;
    },
    async loadUsers() {
      var result={};
      var users=(await api.list("User")).items;
      for(var user of users)
        result[user.id]=user.firstname+" "+user.lastname;
      result[0]="(all)";
      this.users=result;
    },
    async loadWatchStats() {
      var where={};
      var where2={};
      if (this.userId*1) {
        where.userid=this.userId;
        where2.userid=this.userId;
      }
      if (this.videoId*1) {
        where.videoid=this.videoId;
        where2.testid=this.videoId;
      }

      if (this.userId*1)
        api.get("User", this.userId).then((result)=>this.currentUser=result.item);
      else
        this.currentUser={};
      if (this.videoId*1)
        api.get("Video", this.videoId).then((result)=>this.currentTest=result.item);
      else
        this.currentTest={};
      
      this.items=[];
      this.items2=[];
      if ((this.userId*1) || (this.videoId*1)) {
        var promises=[api.list("TestTake", where), api.list("TestUser", where2)];
        var results=await Promise.all(promises);
        this.items=results[0].items.filter((a)=>a.video && a.user);
        this.items2=results[1].items.filter((a)=>a.video && a.user);
      }
      
      
    },
  },
  mounted() {
    this.loadUsers();
    this.loadVideos();
    this.loadWatchStats();
  },
}
</script>
